"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getTypographyFontSize = exports.default = exports.TYPOGRAPHY_BASE_FONT_SIZE_VALUE = exports.TYPOGRAPHY_BASE_FONT_SIZE_KEY = exports.TYPOGRAPHY_BASE_FONT_FAMILY = void 0;
var _Typography = _interopRequireDefault(require("@mui/material/Typography/Typography.js"));
var _react = _interopRequireWildcard(require("react"));
var _useComputedColor2 = require("../../hooks/useComputedColor");
var _excluded = ["variant", "component", "paragraph", "color", "size", "sx"];
function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }
function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return _typeof(key) === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (_typeof(input) !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (_typeof(res) !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
var TYPOGRAPHY_VARIANTS_COMPONENT_MAP = {
  h1: 'h1',
  h2: 'h2',
  body: 'p',
  'body bold': 'p',
  label: 'span',
  'label bold': 'span',
  link: 'a',
  'app header': 'h2',
  button: 'span',
  trumpet: 'span'
};
var TYPOGRAPHY_BASE_FONT_FAMILY = 'Inter';
exports.TYPOGRAPHY_BASE_FONT_FAMILY = TYPOGRAPHY_BASE_FONT_FAMILY;
var TYPOGRAPHY_BASE_FONT_SIZE_KEY = '--base';
exports.TYPOGRAPHY_BASE_FONT_SIZE_KEY = TYPOGRAPHY_BASE_FONT_SIZE_KEY;
var TYPOGRAPHY_BASE_FONT_SIZE_VALUE = '1rem';
exports.TYPOGRAPHY_BASE_FONT_SIZE_VALUE = TYPOGRAPHY_BASE_FONT_SIZE_VALUE;
var getTypographyFontSize = function getTypographyFontSize(multiplier) {
  return "calc(var(".concat(TYPOGRAPHY_BASE_FONT_SIZE_KEY, ") * ").concat(multiplier, ")");
};
exports.getTypographyFontSize = getTypographyFontSize;
var TYPOGRAPHY_VARIANTS_STYLE = {
  h1: {
    fontSize: getTypographyFontSize(1.375),
    fontWeight: 700,
    lineHeight: 1.4
  },
  h2: {
    fontSize: getTypographyFontSize(0.9375),
    fontWeight: 600,
    lineHeight: 1.4
  },
  body: {
    fontSize: getTypographyFontSize(0.8125),
    fontWeight: 400,
    lineHeight: 1.4
  },
  'body bold': {
    fontSize: getTypographyFontSize(0.8125),
    fontWeight: 600,
    lineHeight: 1.4
  },
  label: {
    fontSize: getTypographyFontSize(0.6875),
    fontWeight: 400,
    lineHeight: 1.4
  },
  'label bold': {
    fontSize: getTypographyFontSize(0.6875),
    fontWeight: 600,
    lineHeight: 1
  },
  link: {
    fontSize: getTypographyFontSize(0.8125),
    fontWeight: 700,
    lineHeight: 1.4,
    textDecoration: 'underline'
  },
  'app header': {
    fontSize: getTypographyFontSize(0.75),
    fontWeight: 600,
    lineHeight: 1,
    textTransform: 'uppercase',
    letterSpacing: getTypographyFontSize(0.18)
  },
  button: {
    fontSize: getTypographyFontSize(0.8125),
    fontWeight: 700,
    lineHeight: 1
  },
  trumpet: {
    fontSize: getTypographyFontSize(0.6875),
    fontWeight: 900,
    lineHeight: 1,
    textTransform: 'uppercase'
  }
};
var Typography = /*#__PURE__*/(0, _react.forwardRef)(function (_ref, ref) {
  var _TYPOGRAPHY_VARIANTS_, _objectSpread2;
  var variant = _ref.variant,
    componentProp = _ref.component,
    paragraph = _ref.paragraph,
    colorProp = _ref.color,
    sizeProp = _ref.size,
    sx = _ref.sx,
    rest = _objectWithoutProperties(_ref, _excluded);
  var _useComputedColor = (0, _useComputedColor2.useComputedColor)({
      color: colorProp,
      defaultColor: 'secondary'
    }),
    color = _useComputedColor.computedColor;
  var component = (0, _react.useMemo)(function () {
    var defaultComponent = 'p';
    if (paragraph) {
      return defaultComponent;
    }
    if (componentProp) {
      return componentProp;
    }
    if (variant) {
      return TYPOGRAPHY_VARIANTS_COMPONENT_MAP[variant];
    }
    return defaultComponent;
  }, [componentProp, paragraph, variant]);
  var typoSx = TYPOGRAPHY_VARIANTS_STYLE[variant || 'body'];
  var fontSize = (TYPOGRAPHY_VARIANTS_STYLE === null || TYPOGRAPHY_VARIANTS_STYLE === void 0 ? void 0 : (_TYPOGRAPHY_VARIANTS_ = TYPOGRAPHY_VARIANTS_STYLE[sizeProp]) === null || _TYPOGRAPHY_VARIANTS_ === void 0 ? void 0 : _TYPOGRAPHY_VARIANTS_.fontSize) || sizeProp || (typoSx === null || typoSx === void 0 ? void 0 : typoSx.fontSize);
  return /*#__PURE__*/_react.default.createElement(_Typography.default, _extends({
    component: component,
    color: color,
    sx: _objectSpread(_objectSpread((_objectSpread2 = {}, _defineProperty(_objectSpread2, TYPOGRAPHY_BASE_FONT_SIZE_KEY, TYPOGRAPHY_BASE_FONT_SIZE_VALUE), _defineProperty(_objectSpread2, "fontFamily", TYPOGRAPHY_BASE_FONT_FAMILY), _objectSpread2), typoSx), {}, {
      fontSize: fontSize
    }, sx),
    ref: ref
  }, rest));
});
var _default = Typography;
exports.default = _default;